import React, { useState } from 'react';
import { THINGS_I_BELIEVE } from '../data';

export default function ThingsIBelieve() {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="beliefs" style={{ padding: '100px 0', background: '#1a1a1a', borderTop: '1px solid rgba(255,255,255,0.07)' }}>
      <div style={{ padding: '0 12%' }}>
        <div className="fade-in" style={{ marginBottom: '56px' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: '11px', letterSpacing: '0.28em', color: 'rgba(250,250,248,0.35)', textTransform: 'uppercase', marginBottom: '16px' }}>
            Convictions
          </div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 5vw, 64px)', fontWeight: 600, color: '#fafaf8', lineHeight: 1, letterSpacing: '-0.03em' }}>
            Things I Believe
          </h2>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1px' }}>
          {THINGS_I_BELIEVE.map((item, i) => (
            <div
              key={i}
              className="fade-in"
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{
                padding: '48px 36px',
                border: '1px solid rgba(250,250,248,0.08)',
                transition: 'border-color 0.3s',
                borderColor: hovered === i ? 'rgba(232,197,71,0.3)' : 'rgba(250,250,248,0.08)',
                position: 'relative',
              }}
            >
              <div style={{
                position: 'absolute', top: '24px', left: '36px',
                fontFamily: 'var(--font-mono)', fontSize: '48px', fontWeight: 300,
                color: 'rgba(232,197,71,0.12)', lineHeight: 1,
              }}>
                "
              </div>
              <div style={{
                fontFamily: 'var(--font-display)', fontSize: '22px', fontWeight: 400,
                fontStyle: 'italic', color: '#fafaf8', lineHeight: 1.45,
                marginBottom: '24px', marginTop: '20px',
              }}>
                {item.quote}
              </div>
              <div style={{ width: '24px', height: '2px', background: '#e8c547', marginBottom: '16px', opacity: 0.5 }} />
              <div style={{
                fontFamily: 'var(--font-mono)', fontSize: '9px', letterSpacing: '0.2em',
                color: 'rgba(250,250,248,0.35)', textTransform: 'uppercase',
              }}>
                {item.context}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
